/**
 * Short two-note chime for an incoming support reply.
 *
 * Synthesised rather than shipped as an asset: a bundled mp3 is another
 * request for ~200ms of sound. Wrapped in try/catch because browsers
 * block audio until the user has interacted with the page — a blocked
 * chime must never break message delivery, so failure is silent and the
 * unread badge carries the signal on its own.
 */
export function playSupportChime(): void {
  try {
    const Ctor =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!Ctor) return;
    const ctx = new Ctor();
    const now = ctx.currentTime;
    for (const [i, freq] of [660, 880].entries()) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + i * 0.12);
      gain.gain.exponentialRampToValueAtTime(0.06, now + i * 0.12 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.12 + 0.18);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + i * 0.12);
      osc.stop(now + i * 0.12 + 0.2);
    }
    setTimeout(() => void ctx.close(), 800);
  } catch {
    /* autoplay blocked or no WebAudio — the badge still shows */
  }
}
